import User from '@/shared/modules/user/user.model'

export default class Client extends User {}
